// extracted by mini-css-extract-plugin
export default {"list":"ContactList_list__csErn","item":"ContactList_item__EZYHO","number":"ContactList_number__2af8f","button":"ContactList_button__7kL4l"};